import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 휴가 입력
 * @param body
 * @returns {Promise<axios.AxiosResponse<any>>}
 * @constructor
 */
const InsertVacation =(body)=>{
    return customAxios.post(myIpAddress+'/vacation/vactionInsert', body);
}
export default InsertVacation;